import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from '@common/service/report.service';

@Component({
  standalone: true,
  selector: 'tmw-export-list',
  template: `
    <button type="button" (click)="export()" class="plus btn btn-info px-2 py-1 position-relative" data-tmw-tooltip="Exporter">
      <i class="bi bi-download"></i>
      <span *ngIf="count > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
        {{ count }}
      </span>
    </button>`,
  imports: [CommonModule, NgbTooltipModule],
})
export class TmwExportListComponent {
  private readonly reportService = inject(ReportService);
  @Input() query: string;
  @Input() params: any;
  @Input() count: number = 0;
  @Output() loading = new EventEmitter<boolean>();

  export() {
    this.loading.emit(true);
    this.reportService
      .generateExcelReport(this.query, {
        params: this.params ?? {},
      })
      .subscribe({
        next: () => this.loading.emit(false),
        error: () => this.loading.emit(false),
        complete: () => this.loading.emit(false),
      });
  }
}
